import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewRef
} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {windowScroll} from "../../services/window-scrolling.service";
import {ToastService} from "../../services/Toast.service";
import {SwitchBoard} from "../../services/SwitchBoard";
import {Session} from "../../services/Session";
import {PlansSearchModel} from "../../models/default-search.model";

declare let _: any;

@Component({
  selector: 'app-client-plans-search',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './client-plans-search.component.html',
  styleUrl: './client-plans-search.component.scss'
})
export class ClientPlansSearchComponent implements OnInit, OnDestroy {
  routeSub: any;
  org: any;
  searchModel: any;
  searchTags: Array<any> = [];
  labels: Array<any> = [];
  reveal: any = {
    search: false
  };
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('searchText') private searchText: ElementRef;

  constructor(private switchBoard: SwitchBoard,
              private toastService: ToastService, private windowScroll: windowScroll,
              private changeDetectionRef: ChangeDetectorRef) {

  }

  @Input() set tags(searchtag) {
    this.searchTags = searchtag;
  }

  ngOnInit(): void {
    this._init();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  _init() {
    this.org = Session.getOrg();
    this.searchModel = new PlansSearchModel();
    this.updateModel();
  }

  updateModel() {
    for (const i in this.searchTags) {
      if (this.searchTags[i].modelValue) {
        this.searchModel[this.searchTags[i].key] = this.searchTags[i].modelValue;
      } else {
        this.searchModel[this.searchTags[i].key] = this.searchTags[i].value;
      }
    }
  }

  toggle($event) {
    this.reveal = {...this.reveal, search: true};
    setTimeout(() => {
      this.searchText.nativeElement.focus();
    }, 50);
  }

  hideReveal(revealFlag) {
    this.windowScroll.enable();
    this.reveal[revealFlag] = false;
    if (!(this.changeDetectionRef as ViewRef).destroyed) {
      this.changeDetectionRef.detectChanges();
    }
  }

  removeSearchTag(tag, index) {
    this.searchTags.splice(index, 1);
    this.searchModel[tag.key] = '';
    if (tag.dropdownKey) {
      this.searchModel[tag.dropdownKey] = [];
    }
    if (tag.selectedArrayKey) {
      this.searchModel[tag.selectedArrayKey] = [];
    }
    if (this.searchTags.length > 0) {
      const obj: any = {searchText: this.searchModel.search, advSearchObj: this.searchModel};
      const data = {filters: this.searchTags, searchObj: obj};
      this.switchBoard.onClientPlansAdvSearch.next(data);
    } else {
      this.switchBoard.onClearMenuFilter.next('clientPlansSearch');
    }
  }

  advanceTasksSearch() {
    this.searchTags = [
      {key: 'search', value: this.searchModel.search, displayName: 'Search'}
    ];
    this.searchTags = this.searchTags.filter(function (obj) {
      return obj.value;
    });
    const obj: any = {searchText: this.searchModel.search, advSearchObj: this.searchModel};
    const data = {filters: this.searchTags, searchObj: obj};
    this.switchBoard.onClientPlansAdvSearch.next(data);
    this.hideReveal('search');
  }

}
